/** Solo and single-host group may use the v4 editor; multi-host pooling stays on legacy. */
export const isEventTypeEditorCrudEligible = ({
  isSolo = false,
  isGroup = false,
  isMultiHost = false,
} = {}) => (Boolean(isSolo) || Boolean(isGroup)) && !isMultiHost

export const isEventTypeEditorCrudEligibleFromKind = ({
  kind,
  poolingType,
} = {}) => isEventTypeEditorCrudEligible({
  isSolo: kind === 'solo',
  isGroup: kind === 'group',
  isMultiHost: Boolean(poolingType),
})

/** Max-invitees / occupancy controls: single-host group only. */
export const shouldShowGroupEventControls = ({
  isGroup = false,
  isMultiHost = false,
  isTeam = false,
} = {}) => Boolean(isGroup) && !isMultiHost && !isTeam
